// extracted by mini-css-extract-plugin
export default {"navbarContainer":"Navbar_navbarContainer__Y8+9Y","navItem":"Navbar_navItem__eFCg1","navItemLogo":"Navbar_navItemLogo__MITHv"};